import OneClickButton from './OneClickButton';
export default OneClickButton;